<div>
	<div class="row">
		<div class="col-6 d-flex align-items-end">
			<span data-testid="SUBSYS2_PATLIST_RESULTS_TXT" class="results">
				{{collectionSize()}} {{labels().PATIENT_TABLE_COMPONENT_RESULTS}}
			</span>
		</div>
		<div class="col-6 d-flex justify-content-end">
			<button data-testid="SUBSYS2_PATLIST_CREATEPAT_BTN" type="button" class="btn d-flex align-items-center mb-3"
				(click)="createPatient()">
				<i class="material-icons">person_add_alt</i>
				{{ labels().PATIENT_TABLE_COMPONENT_CREATE_PAT_BTN }}
			</button>
		</div>
	</div>
</div>

<div class="panel panel-cell panel-thead">

	<div class="row no-gutters">

		<div class="col short-col"></div>
		@if (isTlhexUser()) {
		<div class="col short-col"></div>
		}
		<div data-testid="SUBSYS2_PATLIST_HEADER_PATID" class="col" [class.active]="activeColumn() === fields.patNumber">
			<sortable-header [name]="fields.patNumber" (sort)="onSort($event)">
				{{labels().PATIENT_TABLE_COMPONENT_PATIENT_ID}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PATLIST_HEADER_INITIALS" class="col stretch-col"
			[class.active]="activeColumn() === fields.patInitials">
			<sortable-header [name]="fields.patInitials" (sort)="onSort($event)">
				{{labels().PATIENT_TABLE_COMPONENT_PATIENT_INITIALS}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PATLIST_HEADER_GENDER" class="col stretch-col"
			[class.active]="activeColumn() === fields.patGender">
			<sortable-header [name]="fields.patGender" (sort)="onSort($event)">
				{{labels().PATIENT_TABLE_COMPONENT_PATIENT_GENDER}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PATLIST_HEADER_UPDATEDATE" class="col stretch-col"
			[class.active]="activeColumn() === fields.patModifiedDate">
			<sortable-header [name]="fields.patModifiedDate" (sort)="onSort($event)">
				{{labels().PATIENT_TABLE_COMPONENT_PATIENT_MODIFICATION_DATE}}
			</sortable-header>
			<br>
			<span data-testid="SUBSYS2_PATLIST_HEADER_FORMATDATE_TXT" class="date-format">{{ dateFormat }}</span>
		</div>
		<div data-testid="SUBSYS2_PATLIST_HEADER_ACTIONS" class="col no-link" [class]="{'col-8': isTlhexUser()}">
			{{labels().PATIENT_TABLE_COMPONENT_ACTIONS}}
		</div>

	</div>

</div>

@for (pats of patientList(); track $index) {
@let pat = pats[0];
@let hasPlans = !!pats[0].planId;
<div class="panel panel-cell panel-tr" [class.panel-selectable]="hasPlans"
	[class.selected]="pat.patientId === selectedPatientId()" (click)="hasPlans && (pat.opened = !pat.opened)"
	(keypress)="hasPlans && (pat.opened = !pat.opened)">

	<div class="row no-gutters">

		<div class="col short-col p-0">
			@if (hasPlans) {
			<span data-testid="SUBSYS2_PATLIST_TOGGLE" class="material-icons panel-toggle md-30">
				{{ pat.opened ? 'expand_less' : 'expand_more' }}
			</span>
			}
		</div>
		@if (isTlhexUser()) {
		<div data-testid="SUBSYS2_PATLIST_CELL_PUBLISHED" class="col short-col">
			@if (pat.patientHasPublished) {
			<img class="myhexplan-icon mx-auto" alt="published icon" />
			}
		</div>
		}
		<div data-testid="SUBSYS2_PATLIST_CELL_PATID" class="col">
			{{ pat.patientNumber }}
		</div>
		<div data-testid="SUBSYS2_PATLIST_CELL_INITIALS" class="col stretch-col">
			{{ pat.patientInitials }}
		</div>
		<div data-testid="SUBSYS2_PATLIST_CELL_GENDER" class="col stretch-col">
			<div class="user-holder" [class]="genderClass(pat.patientGender)">
				<span>{{ pat.patientGender }}</span>
			</div>
		</div>
		<div data-testid="SUBSYS2_PATLIST_CELL_UPDATEDATE" class="col stretch-col">
			{{ pat.patientModifiedDate! | convertDate:false }}
		</div>
		<div data-testid="SUBSYS2_PATLIST_CELL_ACTIONS" class="col" [class]="{'col-8': isTlhexUser()}">
			<patient-action [item]="pat" />
		</div>

	</div>

</div>

@if (hasPlans) {
<div [ngbCollapse]="!pat.opened">
	<div class="panel-content">
		<div class="panel panel-tr-content bg-transparent">
			<div class="row no-gutters">
				<div class="col">

					<app-nested-plan-table [plans]="pats" [(selectedPlan)]="selectedPlan" />

				</div>
			</div>
		</div>
	</div>
</div>
}
}


<pagination />